export default __webpack_public_path__ + "static/media/course-bg.890b5610.jpg";